export default "__VITE_ASSET__BK0GvT7x__"